import { useLocation, useNavigate } from "react-router-dom";
import logoIcon from "./assets/icons/logo.svg";
import { ReactComponent as ArrowLeftIcon } from "./assets/icons/arrowLeft.svg";

const visitOpenRoles = () => window.open("https://classplusapp.com/careers/open-role", "_blank");

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state;

  return (
    <div id="navbar">
      {locationState && !locationState.mainPage ? (
        <>
          <button id="navbar-back-button" onClick={() => navigate(-1)}>
            <ArrowLeftIcon />
          </button>
          <h4 id="navbar-title">{locationState.title}</h4>
        </>
      ) : (
        <>
          <img id="navbar-logo" src={logoIcon} alt="" />
          <button className="btn1" onClick={visitOpenRoles}>
            View Open Roles
          </button>
        </>
      )}
    </div>
  );
}
